import request from '@/plugin/axios';

//	1、	培训请假管理设置接口
export function Trianset (data) {
  return request({
    url: request.adornUrl('/sys/config/trianset'),
    method: 'post',
    data
  });
}

//	2、	查询请假配置接口
export function Gettrianset () {
  return request({
    url: request.adornUrl('/sys/config/gettrianset'),
    method: 'get'
  });
}

//  3、	批量更新请假配置接口  删除
export function ManagePartner (data) {
  return request({
    url: request.adornUrl(`/sys/config/updatetrianset/${data.flag}`),
    method: 'post',
    data: data.data
  });
}
